export default __webpack_public_path__ + "static/media/mamovies.551cea2f.png";